import { render, staticRenderFns } from "./UserSelector.vue?vue&type=template&id=f8874806&scoped=true"
import script from "./UserSelector.vue?vue&type=script&lang=js"
export * from "./UserSelector.vue?vue&type=script&lang=js"
import style0 from "./UserSelector.vue?vue&type=style&index=0&id=f8874806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8874806",
  null
  
)

export default component.exports